<template>
<div class="dropdown-item">
  <b>{{ line.heading }}</b>

  <span v-if="line.description">
    <br />
    {{ line.description }}
  </span>

  <!-- Field change log -->
  <ul v-if="line.heading === 'Transaction' && line.updatedInformationFields?.length" class="field-changes">
    <li v-for="(field, index) in line.updatedInformationFields" :key="index">
      <strong>{{ field.fieldName }}</strong>:
      <span class="field-change">{{ field.oldValue }} → {{ field.newValue }}</span>
    </li>
  </ul>

  <br />
  <small v-if="line.username" class="meta">
    {{ line.username }} • {{ new Date(line.timestamp).toLocaleString() }}
  </small>
</div>


</template>
<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {InvoiceHistoryLine} from "@/types/invoice";

export default defineComponent({
  name: 'InvoiceHistoryLine',
  props: {
    line: {
      type: Object as PropType<InvoiceHistoryLine>,
      required: true
    }
  }
});
</script>
<style scoped></style>